export const HULLA_EXPERIENCE_LABEL = {
  SG: 'room-builder-sg',
  AU: 'room-builder-aus',
  US: 'room-builder',
  CA: 'room-builder-ca',
  UK: 'room-builder-uk',
};
